import { INavData } from "@coreui/angular";


export const navItems: INavData[] = [

  {
    name: "Dashboard",
    url: "/dashboard",
    iconComponent: { name: "cil-speedometer" },
    children: [
      {
        name: "Statistic",
        url: "/dashboard",
        icon: "nav-icon-bullet",
      },
      {
        name: "Uncompleted Task",
        url: "/performance",
        icon: "nav-icon-bullet",
      }
    ]
  },
  {
    name: "Sales",
    url: "/sales",
    iconComponent: { name: "cil-dollar" },
  },
  {
    name: "Invoice",
    url: "/invoice",
    iconComponent: { name: "cil-spreadsheet" },
  },
  {
    name: "Quotation",
    url: "/policy",
    iconComponent: { name: "cil-notes" },
  },
  {
    name: "Task",
    url: "/job",
    iconComponent: { name: "cil-task" },
  },
  {
    name: "Renewal",
    url: "Renewal",
    iconComponent: { name: "cil-calendar" },
    children: [
      {
        name: "Motor",
        url: "/renewal",
        icon: "nav-icon-bullet",
      },
      {
        name: "Non-Motor",
        url: "/renewal-non-motor",
        icon: "nav-icon-bullet",
      },
    ]
  },
  {
    name: "Road Tax",
    url: "/road-tax",
    iconComponent: { name: "cil-credit-card" },
  },
  {
    name: "Customer",
    url: "Customer",
    iconComponent: { name: "cil-user" },
    children: [
      {
        name: "Listing",
        url: "/customer",
        icon: "nav-icon-bullet",
      },
      {
        name: "My Favourite",
        url: "/favourite",
        icon: "nav-icon-bullet",
      },
    ]
  },
];
